import { render, staticRenderFns } from "./UserDataFiltering.vue?vue&type=template&id=1db9620e&"
import script from "./UserDataFiltering.vue?vue&type=script&lang=js&"
export * from "./UserDataFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports